import React, { useState, useEffect } from "react";
import "@/App.css";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "sonner";
import HeroSection from "./components/HeroSection";
import PhilosophySection from "./components/PhilosophySection";
import ExperienceSection from "./components/ExperienceSection";
import GallerySection from "./components/GallerySection";
import FoundingCircleSection from "./components/FoundingCircleSection";
import MembershipSection from "./components/MembershipSection";
import MembershipModal from "./components/MembershipModal";
import FloatingNav from "./components/FloatingNav";
import FooterSection from "./components/FooterSection";
import AdminPanel from "./components/AdminPanel";

const AppContent = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAdminOpen, setIsAdminOpen] = useState(false);
  
  // Keyboard shortcut for admin (Ctrl+Shift+A)
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'A') {
        setIsAdminOpen(true);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <div className="App bg-[#030303] min-h-screen cinema-bars">
      
      {/* Main Content */}
      <main className="relative">
        <HeroSection onOpenModal={() => setIsModalOpen(true)} />
        <PhilosophySection />
        <ExperienceSection />
        <GallerySection />
        <FoundingCircleSection />
        <MembershipSection onOpenModal={() => setIsModalOpen(true)} />
        <FooterSection />
      </main>
      
      {/* Floating Navigation */}
      <FloatingNav 
        onOpenModal={() => setIsModalOpen(true)} 
        onOpenAdmin={() => setIsAdminOpen(true)}
      />
      
      {/* Membership Modal */}
      <MembershipModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
      
      {/* Admin Panel */}
      {isAdminOpen && (
        <AdminPanel onClose={() => setIsAdminOpen(false)} />
      )}
      
      {/* Toast Notifications */}
      <Toaster 
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: '#0a0a0a',
            color: '#E5E5E5',
            border: '1px solid rgba(43, 254, 205, 0.2)',
            fontFamily: 'Manrope, sans-serif',
          },
        }}
      />
    </div>
  );
};

function App() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;
